import { PMAX_ERRORS_CODES } from "../constants/pmaxErrorsCodes"

export function isNotPmaxEligibleError(errorCode: string) {
    return PMAX_ERRORS_CODES.includes(errorCode)
}
